var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.toPrint }
            },
            [_vm._v("打印")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.innerNo || "无"))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deprAdjustVoucher.reservedNo || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deprAdjustVoucher.auditPoofNo || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.title))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.creatorName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.createTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.applicantName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.applyStateMap[_vm.deprAdjustVoucher.applyState])
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.applyDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.applyTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.auditorName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.auditStateMap[_vm.deprAdjustVoucher.auditState])
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.auditDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(14),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.auditTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.deprAdjustVoucher.adjustType == 0
              ? _c("span", [_vm._v("高级调整")])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.adjustType == 1
              ? _c("span", [_vm._v("原值调整")])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.adjustType == 2
              ? _c("span", [_vm._v("累计折旧调整")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(16),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deprAdjustVoucher.settleNeeded ? "是" : "否"))
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.deprAdjustVoucher.settleNeeded
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(17),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.deprAdjustVoucher.sellerInnerCode || ""))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.deprAdjustVoucher.settleNeeded
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(18),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.deprAdjustVoucher.settleTaxOffset ? "不含税" : "含税"
                    )
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(19),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deprAdjustVoucher.ledgerRealComName || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(20),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.deprAdjustVoucher.fiscalRevoked
              ? _c("span", { staticClass: "font-red" }, [_vm._v("已冲销")])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.ledgerStateMap[_vm.deprAdjustVoucher.ledgerState]
                    )
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(21),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.ledgerTime || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(22),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.memo || "无"))])
          ])
        ]),
        _vm._v(" "),
        _vm.deprAdjustVoucher.pullBackNo != null &&
        _vm.deprAdjustVoucher.pullBackNo != ""
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(23),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _vm.deprAdjustVoucher.pulledBack
                  ? _c("span", [_vm._v("是")])
                  : _c("span", [_vm._v("否")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.deprAdjustVoucher.pullBackNo != null &&
        _vm.deprAdjustVoucher.pullBackNo != ""
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(24),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.deprAdjustVoucher.pullBackNo))])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.deprAdjustVoucher.pullBackNo != null &&
        _vm.deprAdjustVoucher.pullBackNo != ""
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(25),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.deprAdjustVoucher.rejectCause || ""))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(26),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.deprAdjustVoucher.invalid
              ? _c("span", [_vm._v("是")])
              : _c("span", [_vm._v("否")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(27),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deprAdjustVoucher.invalidCause || ""))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(28),
      _vm._v(" "),
      _vm.itemList != null && _vm.itemList.length > 0
        ? [
            _c(
              "div",
              { staticClass: "table-layout" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.itemList,
                      border: "",
                      "tooltip-effect": "dark"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "devcInnerCode",
                        "min-width": "160",
                        label: "资产编号",
                        fixed: "",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "table-cell-link",
                                  on: {
                                    click: function($event) {
                                      _vm.viewAssetInfo(rows.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.devcInnerCode))]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "retailerComFullName",
                        label: "部门全称",
                        width: "200",
                        fixed: "",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "title",
                        label: "资产描述全称",
                        width: "200",
                        fixed: "",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "name",
                        label: "名称",
                        width: "200",
                        fixed: "",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "model",
                        label: "型号",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "fixedSpec",
                        label: "规格",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "tmpNo",
                        "min-width": "250",
                        label: "系统编号",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerCode",
                        "min-width": "120",
                        label: "资产定义编码",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerDevcBrandCode",
                        "min-width": "150",
                        label: "资产品牌编码",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerDevcBrandName",
                        "min-width": "150",
                        label: "资产品牌",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "quantity",
                        width: "100",
                        label: "数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "theUnit",
                        "min-width": "50",
                        label: "单位"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        "min-width": "100",
                        label: "调整方法"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.deprAdjustMethodMap[rows.row.method]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        "min-width": "100",
                        label: "业务单据类型"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.deprBizTypeMap[rows.row.bizVoucherType]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        "min-width": "100",
                        label: "业务单据号"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.bizVoucherNo))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        "min-width": "120",
                        label: "业务单据费用(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (rows.row.bizVoucherFee || 0).toFixed(2)
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        "min-width": "100",
                        label: "折旧算法"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.deprMethodCodeMap[
                                      rows.row.deprMethodCode
                                    ]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxPrice",
                        align: "right",
                        width: "120",
                        label: "调整前进项税额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(rows.row.taxPrice || 0).toFixed(
                                      2
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxPrice2",
                        align: "right",
                        width: "120",
                        label: "调整后进项税额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.taxPrice2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.taxPrice2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxRate",
                        align: "right",
                        width: "120",
                        label: "调整前进项税率(%)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(rows.row.taxRate || 0).toFixed(2)
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxRate2",
                        align: "right",
                        width: "120",
                        label: "调整后进项税率(%)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.taxRate2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(_vm._s(rows.row.taxRate2.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ntxPrice",
                        align: "right",
                        width: "120",
                        label: "调整前未税金额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(rows.row.ntxPrice || 0).toFixed(
                                      2
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ntxPrice2",
                        align: "right",
                        width: "120",
                        label: "调整后未税金额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.ntxPrice2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.ntxPrice2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "wtxPrice",
                        align: "right",
                        width: "120",
                        label: "调整前含税金额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(rows.row.wtxPrice || 0).toFixed(
                                      2
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "wtxPrice2",
                        align: "right",
                        width: "120",
                        label: "调整后含税金额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.wtxPrice2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.wtxPrice2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "orgWorth",
                        width: "120",
                        label: "调整前资产原值(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.orgWorth != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.orgWorth.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "orgWorth2",
                        width: "120",
                        label: "调整后资产原值(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.orgWorth2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.orgWorth2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "deprWorth",
                        width: "120",
                        label: "调整前近期折旧(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.deprWorth != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.deprWorth.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "deprWorth2",
                        width: "120",
                        label: "调整后近期折旧(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.deprWorth2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.deprWorth2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "durableLife",
                        align: "right",
                        width: "120",
                        label: "调整前使用年限(月)"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "durableLife2",
                        align: "right",
                        width: "120",
                        label: "调整后使用年限(月)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.durableLife2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(_vm._s(rows.row.durableLife2))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "onsetDate",
                        align: "center",
                        width: "120",
                        label: "调整前起算日期"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "onsetDate2",
                        align: "center",
                        width: "120",
                        label: "调整后起算日期"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.onsetDate2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(_vm._s(rows.row.onsetDate2))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rmnWorthRatio",
                        align: "right",
                        width: "120",
                        label: "调整前残值率(%)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(
                                      rows.row.rmnWorthRatio || 0
                                    ).toFixed(2)
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rmnWorthRatio2",
                        align: "right",
                        width: "120",
                        label: "调整后残值率(%)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.rmnWorthRatio2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.rmnWorthRatio2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "aggtDeprWorth",
                        width: "160",
                        label: "调整前累计折旧/摊销(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.aggtDeprWorth != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.aggtDeprWorth.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "aggtDeprWorth2",
                        width: "160",
                        label: "调整后累计折旧/摊销(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.aggtDeprWorthFlag &&
                              rows.row.aggtDeprWorth2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.aggtDeprWorth2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "netWorth",
                        width: "120",
                        label: "调整前净值(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.netWorth != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.netWorth.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "netWorth",
                        width: "120",
                        label: "调整后净值(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.netWorth2 != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(
                                      _vm._s(rows.row.netWorth2.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "deprMonth",
                        width: "100",
                        label: "最后折旧月份"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.deprMonth != null &&
                              rows.row.deprMonth > 0
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.deprMonth))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        "min-width": "100",
                        label: "重算历史折旧"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.recalFlag
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v("是")
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        "min-width": "100",
                        label: "重算起始月份"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", { staticClass: "font-red" }, [
                                _vm._v(_vm._s(rows.row.recalMonth))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        "min-width": "100",
                        label: "重算完成"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.recalDone
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v("已完成")
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      staticClass: "font-red",
                      attrs: {
                        prop: "recalTime",
                        align: "center",
                        width: "160",
                        label: "重算完成时间"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "assetType",
                        width: "100",
                        label: "管理方式",
                        align: "center",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    rows.row.assetType == 0
                                      ? "单品式管理"
                                      : "批量式管理"
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.durableColNames, function(colNameX) {
                      return [
                        _c("el-table-column", {
                          attrs: {
                            label: colNameX,
                            align: "center",
                            width: "200",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._l(scope.row.reservedNoJson, function(
                                    theJson
                                  ) {
                                    return scope.row.reservedNoJson != null
                                      ? [
                                          theJson.text == colNameX
                                            ? _c("span", [
                                                _vm._v(_vm._s(theJson.value))
                                              ])
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("调整单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调整单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("记账凭证号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审批单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调整内容")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要验收结算")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供应商标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调整金额含税")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("生凭公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("生凭状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("生凭时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已冲销")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已作废")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("作废原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69743f61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69743f61","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/assetFiscal/AssetDeprAdjustVoucherView.vue
// module id = 2626
// module chunks = 0